module.exports = __webpack_public_path__ + "static/media/20.fd03444f.mp3";